'use client'

import { useRef, useEffect, useState, useMemo } from 'react'
import { PlayerInterface } from '@foundation-player/loader'
import { Icon } from '@/components/Icon'
import VideoPlayer from '@/components/VideoPlayer/VideoPlayer'
import { type WidgetVideoProps } from '@/types/cms'
import StructuredData from '@/elements/widgets/Video/StructuredData'
import { createPlayerProps, useTracking, useSticky } from './utils'
import styles from './VideoInlineTop.module.scss'
import { PlayerEvent } from '@foundation-player/core'

const WidgetVideoInlineTop = ({ item }: { item: WidgetVideoProps }) => {
  const playerWrapper = useRef<HTMLDivElement>(null)
  const [player, setPlayer] = useState<PlayerInterface | undefined>(undefined)
  const [stickyState, setStickyState] = useSticky(playerWrapper, player)

  const videoContext = item.items[0]
  const videoPlayer = useMemo(
    () => (
      <VideoPlayer
        props={createPlayerProps({
          context: videoContext,
          autoplay: false,
          heartbeatStarttype: 0,
        })}
        providePlayer={setPlayer}
      />
    ),
    [videoContext],
  )

  useTracking(stickyState, 'stickyVideoArticle', videoContext.model.id)

  useEffect(() => {
    const handleSessionEnd = () => {
      setStickyState({ isSticky: false, trigger: 'sessionEnd' })
    }

    if (player) {
      player.addEventListener(PlayerEvent.SessionEnd, handleSessionEnd)
    }

    return () => {
      if (player) {
        player.removeEventListener(PlayerEvent.SessionEnd, handleSessionEnd)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [player])

  return (
    <>
      <StructuredData item={videoContext} />
      <div className={styles.video}>
        <div className={styles.player} key={videoContext.model.id}>
          <div
            ref={playerWrapper}
            className={stickyState.isSticky ? styles.sticky + ' ' + styles['sticky-article'] : undefined}
          >
            <div>
              {videoPlayer}
              {stickyState.isSticky && (
                <button
                  className={styles.close}
                  onClick={() => {
                    player?.pause()
                    setStickyState({ isSticky: false, trigger: 'close' })
                  }}
                >
                  <Icon name="close" />
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default WidgetVideoInlineTop
